module.exports = __webpack_public_path__ + "img/calendar.c0edee4b.png";